<div style="height: 100%">
  <cst-card
    [isLoading]="!facility"
    [compact]="true"
    [headerIcon]="
      facility?.monitoringBlackboxID && monitoringStatus ? null : 'description'
    "
    >
    <ng-template cstCardTitle>
      @if (facility?.monitoringBlackboxID && monitoringStatus) {
        <app-anlage-api-monitoring-status-led
          [status]="monitoringStatus"
        ></app-anlage-api-monitoring-status-led>
      }
      <span i18n="@@Infoportal_ElevatorDetail_FacilityOverview_Title">
        Facility Overview
      </span>
    </ng-template>
    <ng-template cstCardContent>
      @if (facility) {
        <div class="facility-info">
          <div class="facility-info-section">
            <div class="facility-info-title">
              <span i18n="@@Infoportal_ElevatorDetail_FacilityOverview_Facility"
                >Facility</span
                >
              </div>
              <div class="facility-info-content">
                <span
                  ><span
                i18n="
                  @@Infoportal_ElevatorDetail_FacilityOverview_Facility_Location"
                  >Location</span
                  >:</span
                  >
                  <span>{{ facility?.standort }}</span>
                  <span
                    ><span
                i18n="
                  @@Infoportal_ElevatorDetail_FacilityOverview_Facility_NumberInternal"
                    >Number Internal</span
                    >:</span
                    >
                    <span>{{ facility?.anlageNrIntern }}</span>
                    <span
                      ><span
                i18n="
                  @@Infoportal_ElevatorDetail_FacilityOverview_Facility_NumberExternal"
                      >Number External</span
                      >:</span
                      >
                      <span>{{ facility?.anlageNrExtern }}</span>
                    </div>
                  </div>
                  <div class="facility-info-section">
                    <div class="facility-info-title">
                      <span i18n="@@Infoportal_ElevatorDetail_FacilityOverview_Customer"
                        >Customer</span
                        >
                      </div>
                      @if (!customerIsLoading) {
                        <div
                          class="facility-info-content"
                          >
                          @if (this.customer?.id) {
                            <span
                              ><span
                  i18n="
                    @@Infoportal_ElevatorDetail_FacilityOverview_Customer_Name"
                              >Name</span
                              >:</span
                              >
                              <span>{{ customer.name }}</span>
                              <span
                                ><span
                  i18n="
                    @@Infoportal_ElevatorDetail_FacilityOverview_Customer_Address"
                                >Address</span
                                >:</span
                                >
                                <span>{{ customer.adresse }}</span>
                              }
                              @if (!this.customer?.id) {
                                <span
                i18n="
                  @@Infoportal_ElevatorDetail_FacilityOverview_Customer_NoCustomer_Heading"
                                  >No customer yet</span
                                  >
                                  <span
                                    style="opacity: 0.75; font-style: italic"
                i18n="
                  @@Infoportal_ElevatorDetail_FacilityOverview_Customer_NoCustomer_Content"
                                    >This facility has not been used in any contract yet and thus
                there is no customer information available.</span
                                    >
                                  }
                                </div>
                              } @else {
                                <app-shimmer [isLoading]="true" type="custom">
                                  <ng-template shimmerPreviewTemplate>
                                    <app-shimmer-label width="99%"></app-shimmer-label>
                                    <app-shimmer-label width="99%"></app-shimmer-label>
                                  </ng-template>
                                </app-shimmer>
                              }
                            </div>
                            @if (!userIsExternal) {
                              <div class="facility-info-section">
                                <div class="facility-info-title">
                                  <span
                                    i18n="@@Infoportal_ElevatorDetail_FacilityOverview_Beneficiary"
                                    >Beneficiary</span
                                    >
                                  </div>
                                  @if (!beneficiaryIsLoading) {
                                    <div
                                      class="facility-info-content"
                                      >
                                      @if (beneficiaries && beneficiaries.length > 0) {
                                        @for (beneficiary of beneficiaries; track beneficiary; let idx = $index) {
                                          @if (idx > 0) {
                                            <div></div><div></div
                                            >
                                          }
                                          <span
                                            ><span
                    i18n="
                      @@Infoportal_ElevatorDetail_FacilityOverview_Beneficiary_Name"
                                            >Name</span
                                            >:</span
                                            >
                                            <span>{{ beneficiary.name }}</span>
                                            <span
                                              ><span
                    i18n="
                      @@Infoportal_ElevatorDetail_FacilityOverview_Beneficiary_Address"
                                              >Address</span
                                              >:</span
                                              >
                                              <span>{{ beneficiary.addressLine }}</span>
                                            }
                                          }
                                          @if (!beneficiaries || beneficiaries.length === 0) {
                                            <span
                i18n="
                  @@Infoportal_ElevatorDetail_FacilityOverview_Beneficiary_NoBeneficiary_Heading"
                                              >No beneficiary yet</span
                                              >
                                              <span
                                                style="opacity: 0.75; font-style: italic"
                i18n="
                  @@Infoportal_ElevatorDetail_FacilityOverview_Beneficiary_NoBeneficiary_Content"
                                                >This facility has not been used in any contract yet and thus
                there is no beneficiary information available.</span
                                                >
                                              }
                                            </div>
                                          } @else {
                                            <app-shimmer [isLoading]="true" type="custom">
                                              <ng-template shimmerPreviewTemplate>
                                                <app-shimmer-label width="99%"></app-shimmer-label>
                                                <app-shimmer-label width="99%"></app-shimmer-label>
                                              </ng-template>
                                            </app-shimmer>
                                          }
                                        </div>
                                      }
                                      @if (eyeCatcher?.length > 0) {
                                        <div class="facility-info-section">
                                          <div class="facility-info-title">
                                            <span i18n="@@Infoportal_ElevatorDetail_FacilityOverview_MasterData"
                                              >Important Master Data</span
                                              >
                                            </div>
                                            <div class="facility-info-content">
                                              @for (e of eyeCatcher; track e) {
                                                <span>{{ e.label?.trim() }}:</span>
                                                <span>{{ interpreteMasterDataValue(e.value) }}</span>
                                              }
                                            </div>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </ng-template>
                                  <ng-template cstCardActions>
                                    @if (facility.stammdaten) {
                                      <ctrl-btn
                                        [flat]="true"
          i18n-content="
            @@Infoportal_ElevatorDetail_FacilityOverview_BuShowMasterData_Content"
                                        content="Master Data"
          i18n-title="
            @@Infoportal_ElevatorDetail_FacilityOverview_BuShowMasterData_Title"
                                        title="Display all master data"
                                        (click)="showMasterData()"
                                        [disabled]="!facility"
                                      ></ctrl-btn>
                                    }
                                  </ng-template>
                                </cst-card>
                              </div>

